export default import.meta.ROLLDOWN_FILE_URL__19ZTOPB8V4o6vl1IEDd0w